import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=32ce8831&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce8831",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ce8831')) {
      api.createRecord('32ce8831', component.options)
    } else {
      api.reload('32ce8831', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=32ce8831&scoped=true&", function () {
      api.rerender('32ce8831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xmPTbgeT8oMU/JS/comp/Accordion.vue"
export default component.exports